import React, { useEffect, useMemo } from 'react';
import Zendesk, { ZendeskAPI } from 'react-zendesk';
import { useTranslation } from 'react-i18next';
import { assert } from '@kallidus/common';
import { isAdminOrSuperAdmin } from '@ApplicationWide/permissions/userTypes';
import { useAppConfig, DEFAULT_BRAND_COLOR, useLoggedInUser } from '@ApplicationWide/AppConfig';

const ZendeskSupport = () => {
  const { application, company } = useAppConfig();
  const { user } = useLoggedInUser();
  const { t } = useTranslation();
  const theme = company?.baseDetails?.brandColor || DEFAULT_BRAND_COLOR;

  const supportModalProps = useMemo(
    () => ({
      color: { theme },
      launcher: {
        label: { '*': t('common.need-help') },
        chatLabel: { '*': t('common.need-help') },
      },
    }),
    [t, theme],
  );

  // don't show the widget if the user hasn't logged in
  const shouldRender = useMemo(() => Boolean(application) && isAdminOrSuperAdmin(user), [user, application]);

  useEffect(() => {
    if (shouldRender) {
      ZendeskAPI('webWidget', 'updateSettings', supportModalProps);
    }
  }, [shouldRender, supportModalProps]);

  if (!shouldRender) {
    return null;
  }

  assert(application.zendeskApiKey, 'Invalid app configuration - no zendesk key found');

  return (
    <Zendesk
      zendeskKey={application.zendeskApiKey}
      onLoaded={() =>
        ZendeskAPI('webWidget', 'identify', {
          name: user?.fullName,
          email: user?.email,
        })
      }
      {...supportModalProps}
    />
  );
};

export default ZendeskSupport;
